<template lang="pug">
  .invoice-progress.row
    .progress-steps.xs-12.text-center
      span.step.xs-f-xxsmall.max-at-tweak(:class="{ 'completed': true }") Preparing
      .line.xs-f-xxsmall.max-at-tweak(:class="{ 'completed': processing }")
      span.step.xs-f-xxsmall.max-at-tweak(:class="{ 'completed': processing }") Processing
      .line.xs-f-xxsmall.max-at-tweak(:class="{ 'completed': onItsWay }")
      span.step.xs-f-xxsmall.max-at-tweak(:class="{ 'completed': onItsWay }") Shipped
      .line.xs-f-xxsmall.max-at-tweak(:class="{ 'completed': delivered }")
      span.step.xs-f-xxsmall.max-at-tweak(:class="{ 'completed': delivered }") Delivered
  
</template>

<script>
  export default {
    name: "InvoiceStatusBar",
    data() {
      return {
        pending_status: 'pending',
        processing_status: 'processing',
        shipped_status: 'shipped',
        delivered_status: 'delivered'
      }
    },

    props: {
      status: {
        type: String,
        required: true
      }
    },

    computed: {
      processing() {
        return [this.processing_status, this.shipped_status, this.delivered_status].includes(this.status);
      },

      onItsWay() {
        return [this.shipped_status, this.delivered_status].includes(this.status);
      },

      delivered() {
        return this.status == this.delivered_status;
      }
    }
   }
</script>

<style scoped lang="stylus">
  .invoice-progress
    .progress-steps
      padding 0.5em 0

      .step
        position relative
        color #7d7d7d
        padding-top 2em
        display inline-block
        vertical-align top
        width 7em

        &:before
          content ''
          position absolute
          top 0
          left 50%
          height 10px
          width 10px
          margin-left -10px
          border 5px solid #ebebeb
          border-radius 50%
          background-color #ebebeb

        &.completed
          &:after
            content icon-check-nobox
            font-family fontello
            font-size font-size-small
            color color-white
            line-height 20px
            position absolute
            top 0
            left 50%
            height 20px
            width 20px
            margin-left -10px
            border-radius 50%
            background-color color-mr-blue

      .line
        position relative
        width 1em
        display inline-block
        vertical-align top
        padding-top 2.23em

        &:before
          content ''
          position absolute
          bottom 1.1em
          left 50%
          height 0.36em
          width 6em
          margin-left -3em
          background-color #ebebeb

        &.completed
          &:before
            background-color color-mr-blue
</style>